'use strict';

/* ─────────────────────────────────────────────────────────────────
   Represent CLO — Sticky Add to Cart Bar
   Shows when main ATC button scrolls out of view (mobile only).
   Uses IntersectionObserver only. No rAF loops. iOS Safari safe.
───────────────────────────────────────────────────────────────── */

(function () {
  if (window.innerWidth >= 750) return;

  var bar    = document.getElementById('rp-sticky-atc');
  var anchor = document.getElementById('rp-main-atc-anchor');

  if (!bar || !anchor) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        bar.classList.remove('is-visible');
      } else {
        bar.classList.add('is-visible');
      }
    });
  }, { threshold: 0 });

  io.observe(anchor);

  /* Sticky button click → submit the product form */
  var stickyBtn = bar.querySelector('.rp-sticky-atc__btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var submitBtn = document.querySelector('.product-form__submit:not([name="goto_pp"])');
      if (submitBtn) submitBtn.click();
    }, { passive: true });
  }
})();
